import {Time} from 'yougile-util'
import {DataObjectId} from 'yougile-model'
import {useTimelineNewStore} from '@components/timeline-new/timeline-new-store'
import {DeadlineState} from '@components/timeline-new/types'

export const useSnappedDeadline = (
  hubId: DataObjectId,
  path: string
): {
  start: number | undefined
  end: number | undefined
  state: DeadlineState
} => {
  const [state, store] = useTimelineNewStore()
  if (!(hubId in state.itemDataRegistry)) {
    return {start: undefined, end: undefined, state: DeadlineState.Planned}
  }

  const dragging = state.draggingPath === path
  const {deadline} = state.itemDataRegistry[hubId]

  let start: number | undefined
  let end: number | undefined
  if (dragging) {
    start = state.draggingStart
    end = state.draggingEnd
  } else if (deadline.start && deadline.end) {
    start = deadline.start
    end = deadline.end
  }

  if (!start || !end) {
    return {start: undefined, end: undefined, state: DeadlineState.Planned}
  }

  let deadlineState = DeadlineState.Planned
  const now = Time.now()
  if (end && now > end) {
    deadlineState = DeadlineState.Expired
  } else if (start && now > start) {
    deadlineState = DeadlineState.InProgress
  }

  start = store.startTimeToSnappedTime(start)
  end = store.endTimeToSnappedTime(end)

  return {start, end, state: deadlineState}
}
